import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
// import flow_en from './flow_en.png';
// import flow_cn from './flow_chi.png';
import flow_en from '../images/procedureEng.png';
import flow_cn from '../images/procedureChi.png';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const styles = theme => ({
    container: {
        width: '95%'
    },
    root: {
      width: '95%',
      minHeight: '500px',
      //marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      margin: '0 Auto',
      //display: 'flex',
      //justifyContent: 'center',
    },
    table: {
      tableLayout: 'auto',
      minWidth: 300,
    },
    header:{
        backgroundColor: 'primary',
    },
    leftCell: {
        borderRight: '0.1em solid rgba(224, 224, 224, 1)',
    },
  });
class ArbitrationProcedure extends Component {
    
       
        render(){
            return (
                <div style={{textAlign:'center'}}>
                    {(this.props.lang == 'en') && <img src={flow_en} width="60%" height="60%" />}
                    {(this.props.lang == 'cn') && <img src={flow_cn} width="60%" height="60%" />}
                </div>
            );
        }
    
  }
const mapStateToProps = (state) => {
    console.log('ArbitrationProcedure state: '+JSON.stringify(state))
    return {
        lang: state.i18nState.lang
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

ArbitrationProcedure.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ArbitrationProcedure)));

// export default withStyles(styles)(ArbitrationProcedure);